<ng-container *ngIf="hasVariations$ | async">
  <a id="variation-list-top" title="top"></a>
  <ish-filter-navigation orientation="horizontal" fragmentOnRouting="variation-list-top" />
  <ish-product-listing
    mode="paging"
    [categoryId]="categoryId$ | async"
    [productListingId]="{ type: 'master', value: sku$ | async }"
    fragmentOnRouting="variation-list-top"
  />
</ng-container>
